export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";